export const selectFeatureFlags = (state) => state.featureFlags?.flags ?? {};

export const selectIsFeatureFlagEnabled = (flagName) => (state) =>
  Boolean(state.featureFlags?.flags?.[flagName]);

export const selectFeatureFlagsLoaded = (state) =>
  Boolean(state.featureFlags?.loaded);

export const selectFeatureFlagsResolved = (state) =>
  Boolean(state.featureFlags?.loaded) || state.featureFlags?.error != null;

export const selectFeatureFlagDetails = (state) =>
  state.featureFlags?.details ?? [];

export const selectFeatureFlagDetailsLoading = (state) =>
  Boolean(state.featureFlags?.detailsLoading);

export const selectFeatureFlagDetailsError = (state) =>
  state.featureFlags?.detailsError ?? null;
